import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer-auth content" }
const _hoisted_2 = { class: "footer-auth__item" }
const _hoisted_3 = { class: "footer-auth__item" }
const _hoisted_4 = { class: "footer-auth__item-title" }
const _hoisted_5 = { class: "footer-auth__item-desc" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", {
  class: "footer-auth__item-link",
  href: "tel:+7(999)999-99-99"
}, "+7 (999) 999-99-99", -1)
const _hoisted_7 = { class: "footer-auth__item" }
const _hoisted_8 = { class: "footer-auth__item-title" }
const _hoisted_9 = { class: "footer-auth__item-desc" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("a", {
  class: "footer-auth__item-link",
  href: "mailto:info@topseller.com"
}, "info@topseller.com", -1)
const _hoisted_11 = { class: "footer-auth__item" }
const _hoisted_12 = { class: "footer-auth__item-title" }
const _hoisted_13 = { class: "footer-auth__item-links" }
const _hoisted_14 = { class: "footer-auth__item" }
const _hoisted_15 = { class: "footer-auth__item-title" }

import Button from '@/components/ui/Button'

export default /*#__PURE__*/_defineComponent({
  __name: 'Auth',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_draw_svg = _resolveComponent("draw-svg")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_router_link, { to: {name: 'Main'} }, {
          default: _withCtx(() => [
            _createVNode(_component_draw_svg, {
              name: "logo",
              class: "footer-auth__logo",
              width: "160",
              height: "38"
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", null, _toDisplayString(_ctx.$t('copy')), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('footer.call.title')), 1),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('footer.call.desc')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('footer.write.title')), 1),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('footer.write.desc')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('footer.toClients')), 1),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_router_link, {
          to: {name: 'Privacy'},
          "active-class": "active",
          "exact-active-class": "active"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('footer.privacy')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: {name: 'Agreements'},
          "active-class": "active",
          "exact-active-class": "active"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('footer.agreements')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: {name: 'Offer'},
          "active-class": "active",
          "exact-active-class": "active"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('footer.offer')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_unref(Button), {
          type: "a",
          theme: "tg",
          href: _ctx.$t('common.buttons.chat.link')
        }, {
          append: _withCtx(() => [
            _createVNode(_component_draw_svg, {
              name: "tg",
              width: "18",
              height: "18"
            })
          ]),
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.buttons.chat.title')) + " ", 1)
          ]),
          _: 1
        }, 8, ["href"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_unref(Button), {
          type: "a",
          theme: "tg",
          href: _ctx.$t('common.buttons.channel.link')
        }, {
          append: _withCtx(() => [
            _createVNode(_component_draw_svg, {
              name: "tg",
              width: "18",
              height: "18"
            })
          ]),
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.buttons.channel.title')) + " ", 1)
          ]),
          _: 1
        }, 8, ["href"])
      ])
    ])
  ]))
}
}

})